import React, { useEffect, useMemo, useState } from "react";
import "./AdminWalletTopupOffers.css";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "";

/* Toggle mini stile Promozioni */
function ToggleMini({ checked, onChange, label }) {
  return (
    <label className="wallet-toggle">
      <input
        type="checkbox"
        checked={!!checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="wallet-tknob" />
      {label ? <span className="wallet-tlabel">{label}</span> : null}
    </label>
  );
}

const formatMoney = (v) =>
  Number(v || 0).toLocaleString("it-IT", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export default function AdminWalletTopupOffers() {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");
  const [onlyActive, setOnlyActive] = useState(false);
  const [grpOpen, setGrpOpen] = useState(true);

  const [form, setForm] = useState({
    id: null,
    base_amount_eur: "",
    credit_amount_eur: "",
    title: "",
    description: "",
    active: true,
    sort_order: 0,
  });

  const token = localStorage.getItem("token");

  const fetchOffers = async () => {
    try {
      setLoading(true);
      setErr("");
      const res = await fetch(`${API_BASE}/api/wallet/admin/topup-offers`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: token ? `Bearer ${token}` : "",
        },
      });
      if (!res.ok) throw new Error("Errore caricamento offerte");
      const data = await res.json();
      setOffers(data.offers || []);
    } catch (e) {
      console.error(e);
      setErr("Errore caricamento offerte");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOffers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const resetForm = () =>
    setForm({
      id: null,
      base_amount_eur: "",
      credit_amount_eur: "",
      title: "",
      description: "",
      active: true,
      sort_order: 0,
    });

  const handleEdit = (off) => {
    setForm({
      id: off.id,
      base_amount_eur: off.base_amount_eur,
      credit_amount_eur: off.credit_amount_eur,
      title: off.title || "",
      description: off.description || "",
      active: off.active,
      sort_order: off.sort_order || 0,
    });
    // scroll al form per evitare caccia al tesoro
    const el = document.querySelector(".wallet-panel");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Eliminare questa offerta?")) return;
    try {
      const res = await fetch(
        `${API_BASE}/api/wallet/admin/topup-offers/${id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: token ? `Bearer ${token}` : "",
          },
        }
      );
      if (!res.ok) throw new Error("Errore eliminazione");
      await fetchOffers();
    } catch (e) {
      console.error(e);
      alert("Errore eliminazione offerta");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        base_amount_eur: Number(form.base_amount_eur),
        credit_amount_eur: Number(form.credit_amount_eur),
        title: form.title || null,
        description: form.description || null,
        active: !!form.active,
        sort_order: Number(form.sort_order) || 0,
      };

      const isEdit = !!form.id;
      const url = isEdit
        ? `${API_BASE}/api/wallet/admin/topup-offers/${form.id}`
        : `${API_BASE}/api/wallet/admin/topup-offers`;
      const method = isEdit ? "PUT" : "POST";

      const res = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: token ? `Bearer ${token}` : "",
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.error || "Errore salvataggio offerta");
      }

      resetForm();
      await fetchOffers();
    } catch (e) {
      console.error(e);
      alert(e.message || "Errore salvataggio offerta");
    }
  };

  const filteredOffers = useMemo(
    () => (onlyActive ? offers.filter((o) => o.active) : offers),
    [offers, onlyActive]
  );

  const bonusPreview = useMemo(() => {
    const base = Number(form.base_amount_eur);
    const credit = Number(form.credit_amount_eur);
    if (!base || !credit || !Number.isFinite(base) || !Number.isFinite(credit))
      return null;
    const diff = credit - base;
    if (diff <= 0) return null;
    const perc = (diff / base) * 100;
    return {
      bonusEur: formatMoney(diff),
      bonusPerc: perc.toFixed(1),
    };
  }, [form.base_amount_eur, form.credit_amount_eur]);

  if (loading) {
    return (
      <div className="wallet-topup-page">
        <div className="promo-empty">Caricamento offerte ricarica…</div>
      </div>
    );
  }

  if (err) {
    return (
      <div className="wallet-topup-page">
        <div className="wallet-error">{err}</div>
      </div>
    );
  }

  return (
    <div className="wallet-topup-page">
      <h1>Offerte ricarica carta prepagata</h1>

      <div className="wallet-group-card">
        <div className="wallet-group-head">
          <button
            type="button"
            className="wallet-gh-left"
            onClick={() => setGrpOpen((v) => !v)}
          >
            <span className="wallet-gh-arrow">{grpOpen ? "▾" : "▸"}</span>
            <span className="wallet-gh-title">Ricariche con bonus</span>
            <span className="wallet-gh-count">{offers.length}</span>
          </button>
          <div className="wallet-gh-right">
            <div className="wallet-gh-toggle-wrap">
              <ToggleMini
                checked={onlyActive}
                onChange={setOnlyActive}
                label="Solo attive"
              />
            </div>
            {form.id && (
              <button
                type="button"
                className="btn-lite wallet-btn-lite"
                onClick={resetForm}
              >
                Nuova offerta
              </button>
            )}
          </div>
        </div>

        {grpOpen && (
          <div className="wallet-group-body">
            {/* PANEL FORM */}
            <div className="wallet-panel">
              <div className="wallet-panel-head">
                <div className="wallet-panel-title">
                  {form.id
                    ? `Modifica offerta #${form.id}`
                    : "Nuova offerta ricarica"}
                </div>
              </div>
              <div className="wallet-panel-body">
                <form
                  className="form-grid wallet-form-grid"
                  onSubmit={handleSubmit}
                >
                  <label className="span-3">
                    <span className="wallet-field-label">
                      Importo pagato (€)
                    </span>
                    <input
                      type="number"
                      min="0"
                      step="0.01"
                      className="wallet-input"
                      value={form.base_amount_eur}
                      onChange={(e) =>
                        setForm((f) => ({
                          ...f,
                          base_amount_eur: e.target.value,
                        }))
                      }
                      required
                    />
                    <span className="wallet-hint">
                      Es. il cliente paga 50&nbsp;€ e ne riceve 55&nbsp;€ di
                      credito.
                    </span>
                  </label>

                  <label className="span-3">
                    <span className="wallet-field-label">
                      Credito accreditato (€)
                    </span>
                    <input
                      type="number"
                      min="0"
                      step="0.01"
                      className="wallet-input"
                      value={form.credit_amount_eur}
                      onChange={(e) =>
                        setForm((f) => ({
                          ...f,
                          credit_amount_eur: e.target.value,
                        }))
                      }
                      required
                    />
                    {bonusPreview && (
                      <span className="wallet-bonus-preview">
                        Bonus: +{bonusPreview.bonusEur} € (
                        {bonusPreview.bonusPerc}%)
                      </span>
                    )}
                  </label>

                  <label className="span-3">
                    <span className="wallet-field-label">
                      Titolo (opzionale)
                    </span>
                    <input
                      type="text"
                      className="wallet-input"
                      value={form.title}
                      onChange={(e) =>
                        setForm((f) => ({ ...f, title: e.target.value }))
                      }
                      placeholder="Es. Ricarica 50 → 55"
                    />
                  </label>

                  <label className="span-3">
                    <span className="wallet-field-label">Ordine</span>
                    <input
                      type="number"
                      className="wallet-input"
                      value={form.sort_order}
                      onChange={(e) =>
                        setForm((f) => ({ ...f, sort_order: e.target.value }))
                      }
                    />
                    <span className="wallet-hint">
                      Più basso → mostrata più in alto.
                    </span>
                  </label>

                  <label className="span-6">
                    <span className="wallet-field-label">
                      Descrizione (opzionale)
                    </span>
                    <textarea
                      className="wallet-input wallet-textarea"
                      value={form.description}
                      onChange={(e) =>
                        setForm((f) => ({
                          ...f,
                          description: e.target.value,
                        }))
                      }
                      placeholder="Testo descrittivo da mostrare nel profilo ricariche."
                    />
                  </label>

                  <label className="span-3">
                    <span className="wallet-field-label">Stato</span>
                    <ToggleMini
                      checked={form.active}
                      onChange={(v) => setForm((f) => ({ ...f, active: v }))}
                      label={
                        form.active ? "Offerta attiva" : "Offerta non attiva"
                      }
                    />
                  </label>

                  <div className="wallet-form-actions span-6">
                    <button type="submit" className="btn-cta">
                      {form.id ? "Aggiorna offerta" : "Crea offerta"}
                    </button>
                    {form.id && (
                      <button
                        type="button"
                        className="btn-lite"
                        onClick={resetForm}
                      >
                        Annulla modifica
                      </button>
                    )}
                  </div>
                </form>
              </div>
            </div>

            {/* LISTA OFFERTE */}
            <div className="wallet-divider" />

            {filteredOffers.length === 0 ? (
              <div className="promo-empty">
                Nessuna offerta configurata. Aggiungine una dal form sopra.
              </div>
            ) : (
              <div className="list table wallet-table">
                <div className="thead">
                  <div>ID</div>
                  <div>Paghi</div>
                  <div>Credito</div>
                  <div>Bonus</div>
                  <div>Titolo</div>
                  <div>Stato</div>
                  <div>Ord.</div>
                  <div className="ta-right">Azioni</div>
                </div>

                {filteredOffers.map((o) => {
                  const base = Number(o.base_amount_eur || 0);
                  const credit = Number(o.credit_amount_eur || 0);
                  const diff = credit - base;
                  const perc =
                    base > 0 && diff > 0
                      ? ((diff / base) * 100).toFixed(1)
                      : null;

                  return (
                    <div
                      key={o.id}
                      className={
                        o.active
                          ? "trow wallet-row"
                          : "trow wallet-row wallet-row--off"
                      }
                    >
                      <div>{o.id}</div>
                      <div>{formatMoney(o.base_amount_eur)} €</div>
                      <div>{formatMoney(o.credit_amount_eur)} €</div>
                      <div>
                        +{formatMoney(o.bonus_eur)} €{perc ? ` (${perc}%)` : ""}
                      </div>
                      <div className="wallet-ellipsis">
                        {o.title || <span className="wallet-muted">—</span>}
                      </div>
                      <div className="nowrap">
                        {o.active ? "Attiva" : "Non attiva"}
                      </div>
                      <div>{o.sort_order}</div>
                      <div className="ta-right">
                        <div className="wallet-row-actions">
                          <button
                            type="button"
                            className="btn-icon"
                            title="Modifica"
                            onClick={() => handleEdit(o)}
                            aria-label="Modifica"
                          >
                            ✏️
                          </button>
                          <button
                            type="button"
                            className="btn-icon"
                            title="Elimina"
                            onClick={() => handleDelete(o.id)}
                            aria-label="Elimina"
                          >
                            🗑
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
